import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Input, Radio, RadioChangeEvent, Row, Select, Space } from "antd";

import AddressMaker, { AddressType } from "./AddressMaker";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterCarType({ editMode, carType, onRegisterCarType }: { editMode: string; carType?: Types.CarTypeDto; onRegisterCarType?: () => void }) {
    const [form] = Form.useForm();
    const alert = useAlert();

    const [typeId, setTypeId] = useState("");
    const [typeName, setTypeName] = useState("");
    const [price, setPrice] = useState("");
    const [unavailable, setunavailable] = useState("");
    const [modelId, setModelId] = useState(0);

    const requestAxiosAddCarType = async (data: Types.CarTypeDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().post(Request.CAR_TYPE_URL, data);

        return response.data;
    };

    const {
        loading: loadingAddCarType,
        error: errorAddCarType,
        data: resultAddCarType,
        execute: requestAddCarType,
    } = useAsyncAxios(requestAxiosAddCarType);

    useEffect(() => {
        if (carType === undefined) return;

        form.setFieldsValue(carType);

        form.setFieldsValue({
            modelId: carType.model.modelId,
        });

        setModelId(Number(carType.model.modelId));
    }, [carType]);

    useEffect(() => {
        if (resultAddCarType === null) return;

        if (onRegisterCarType) onRegisterCarType();

        alert.setAlert(AlertType.SUCCESS, "타입 추가 성공", "타입 추가를 완료하였습니다.");
    }, [resultAddCarType]);

    useEffect(() => {
        if (errorAddCarType === null) return;

        console.log("errorCarType", errorAddCarType);
        alert.setAlert(errorAddCarType.response.data.code, "타입 추가 실패", errorAddCarType.response.data.message);
    }, [errorAddCarType]);

    const requestAxiosUpdateCarType = async (data: Types.CarTypeDto) => {
        // console.log("data : " + data.model);

        const response = await utilAxiosWithAuth().put(Request.CAR_TYPE_URL + "/" + data.typeId, data);

        return response.data;
    };

    const {
        loading: loadingUpdateCarType,
        error: errorUpdateCarType,
        data: resultUpdateCarType,
        execute: requestUpdateCarType,
    } = useAsyncAxios(requestAxiosUpdateCarType);

    useEffect(() => {
        if (resultUpdateCarType === null) return;

        if (onRegisterCarType) onRegisterCarType();

        alert.setAlert(AlertType.SUCCESS, "타입 수정 성공", "타입 수정을 완료하였습니다.");
    }, [resultUpdateCarType]);

    useEffect(() => {
        if (errorUpdateCarType === null) return;

        console.log("errorUpdateCarType", errorUpdateCarType);
        alert.setAlert(errorUpdateCarType.response.data.code, "타입 수정 실패", errorUpdateCarType.response.data.message);
    }, [errorUpdateCarType]);

    const onFinish = (values: any) => {
        delete values["confirm"];

        const data: Types.CarTypeDto = {
            ...values,
            model: {
                modelId: modelId,
                modelName: "",
                unavailable: false,
            },
        };
        console.log("Received values of form: ", data);

        if (editMode === "add") requestAddCarType(data);
        else if (editMode === "update") requestUpdateCarType(data);
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={8}>
                            <Form.Item className="searchForm" {...formItemLayout} name="typeId" label="타입 ID">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="typeName"
                                label="타입 이름"
                                rules={[
                                    {
                                        required: true,
                                        message: "타입 이름을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="타입 이름을 입력해 주세요." onChange={(e) => setTypeName(e.target.value)} />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="price"
                                label="타입 가격"
                                rules={[
                                    {
                                        required: true,
                                        message: "가격을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="가격을 입력해 주세요." onChange={(e) => setPrice(e.target.value)} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="unavailable" label="비활성화">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="modelId"
                                label="모델 ID"
                                rules={[
                                    {
                                        required: true,
                                        message: "모델 ID를 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="모델 ID를 입력해 주세요." onChange={(e) => setModelId(Number(e.target.value))} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RegisterCarType;
